/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import { Container } from 'unstated'

export class AppContainer extends Container {
  state = {
    currentConfig: 'Config B',
    currentLocation: 'Loc1',
    currentSeason: 'Annual',
  }

  setConfig = async newConfig => {
    if (!newConfig) return
    await this.setState({ currentConfig: newConfig })
  }

  setLocation = async newLocation => {
    if (!newLocation) return
    await this.setState({ currentLocation: newLocation })
  }

  setSeason = async newSeason => {
    if (!newSeason) return
    await this.setState({ currentSeason: newSeason })
  }
}
